module.exports = __webpack_public_path__ + "static/media/test9_2.f5ddbad0.png";